// Smooth scrolling for navigation links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Add scroll effect to navigation
window.addEventListener('scroll', () => {
    const nav = document.querySelector('nav');
    if (window.scrollY > 100) {
        nav.classList.add('backdrop-blur-sm');
    } else {
        nav.classList.remove('backdrop-blur-sm');
    }
});

// Mobile menu toggle with animation
const navToggle = document.getElementById('nav-toggle');
const mobileMenu = document.getElementById('mobile-menu');
if (navToggle && mobileMenu) {
    const openMenu = () => {
        const fullHeight = mobileMenu.scrollHeight;
        mobileMenu.style.maxHeight = fullHeight + 'px';
        mobileMenu.style.opacity = '1';
        navToggle.setAttribute('aria-expanded', 'true');
    };
    const closeMenu = () => {
        mobileMenu.style.maxHeight = '0';
        mobileMenu.style.opacity = '0';
        navToggle.setAttribute('aria-expanded', 'false');
    };

    // Toggle on click
    navToggle.addEventListener('click', () => {
        const isOpen = navToggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) closeMenu(); else openMenu();
    });

    // Close mobile menu when a link is clicked (with animation)
    mobileMenu.querySelectorAll('a[href*="#"]').forEach(link => {
        link.addEventListener('click', () => {
            closeMenu();
        });
    });

    // Ensure menu is collapsed on load
    closeMenu();
}